import React from "react";
import ErrorMessage from "./ErrorMessage";
import CommonButtons from "src/shared/components/CommonButtons";

interface PaymentFormProps {
  amount: string;
  onAmountChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onAmountFocus: () => void;
  onCancel: () => void;
  onConfirm: () => void;
  paymentMethod: string;
  Loading: boolean;
}

const PaymentForm: React.FC<PaymentFormProps> = ({ amount, onAmountChange, onAmountFocus, onCancel, onConfirm, paymentMethod, Loading = false }) => {
  const isInvalid = parseFloat(amount) <= 0;

  return (
    <div className='space-y-4 p-4 border rounded-2xl bg-gray-200' id='pay-drawer-body'>
      <h1 className='text-lg font-bold'>{paymentMethod} :</h1>

      <label className='flex items-center gap-2'>
        <span className='font-semibold'>Received price :</span>
        <input
          type='number'
          value={amount}
          onChange={onAmountChange}
          onFocus={onAmountFocus}
          className='w-24 rounded-lg border-2 border-black px-2 py-1'
          id='pay-input-amount'
        />
      </label>

      <div className='flex justify-between'>
        <CommonButtons className='w-[120px] h-10' label='Cancel' variant='outlineDanger' onClick={onCancel} />

        <CommonButtons className='w-28 h-10' label='Pay' onClick={onConfirm} disabled={isInvalid || Loading} variant='primary' />
      </div>

      {isInvalid && <ErrorMessage id='pay-validation-msg' message='Please enter an amount greater than 0' />}
    </div>
  );
};

export default PaymentForm;
